import { useState } from 'react';

import { Label } from '@shared/forms/components/Label';
import { createTimeTrackingEntry } from '@shared/time-tracking-entries/endpoints/createTimeTrackingEntry';
import { endTimeTrackingEntry } from '@shared/time-tracking-entries/endpoints/endTimeTrackingEntry';
import { Portlet } from '@shared/ui/components/Portlet';
import { Select } from '@shared/ui/components/Select';
import { cn } from '@shared/utils/helpers';
import { PropsWithClassName } from '@shared/utils/types';

import { EndTimeTrackingWithBarcodeForm } from '@admin/time-tracking/components/EndTimeTrackingWithBarcodeForm/EndTimeTrackingWithBarcodeForm';
import { StartTimeTrackingWithBarcodeForm } from '@admin/time-tracking/components/StartTimeTrackingWithBarcodeForm/StartTimeTrackingWithBarcodeForm';

type Props = {
  timeTrackingGroupId: number;
  onStartOrEnd?: () => void;
};

export default function BarcodeTimeTrackingPortlet({
  timeTrackingGroupId,
  onStartOrEnd,
  className,
}: PropsWithClassName<Props>) {
  const [scanningType, setScanningType] = useState<'start' | 'end'>('start');

  return (
    <Portlet
      className={cn(className, '@container')}
      innerClassName="grid grid-cols-1 @sm:grid-cols-[max-content_auto] gap-5"
    >
      <div>
        <div className="grid gap-2">
          <Label>Scan Type</Label>
          <Select
            className="min-w-[11ch]"
            options={[
              {
                label: 'Start',
                value: 'start',
              },
              {
                label: 'End',
                value: 'end',
              },
            ]}
            value={scanningType}
            onChange={(value) => setScanningType(value as 'start' | 'end')}
          />
        </div>
      </div>

      {scanningType === 'start' && (
        <StartTimeTrackingWithBarcodeForm
          timeTrackingGroupId={timeTrackingGroupId}
          action={createTimeTrackingEntry}
          onSave={() => onStartOrEnd?.()}
        />
      )}
      {scanningType === 'end' && (
        <EndTimeTrackingWithBarcodeForm
          timeTrackingGroupId={timeTrackingGroupId}
          action={endTimeTrackingEntry}
          onSave={() => onStartOrEnd?.()}
        />
      )}
    </Portlet>
  );
}
